<template>
  <div class="page-wrapper">

    <!-- 🔵 Хедер как у вакансии -->
    <DefaultHeader
      title="Создание компании"
      back
      class="fixed-header"
      :offset="660"
    />

    <!-- 🩶 Серый фон -->
    <div class="page-bg">

      <!-- Шаг над контейнером -->
      <div class="step-title-wrapper">
        <h2 class="step-title">
          Шаг {{ currentStep }} из {{ totalSteps }}
        </h2>
      </div>

      <!-- Белый контейнер -->
      <div class="step-container">

        <!-- Прогресс бар -->
        <div class="progress-bar">
          <div
            class="progress-fill"
            :style="{ width: progressWidth }"
          >
            <span class="progress-shine"></span>
          </div>
        </div>

        <!-- Кнопки -->
        <div class="step-buttons">
          <button
            v-if="currentStep === 1"
            class="btn cancel"
            type="button"
            @click="handleCancel"
          >
            <span class="button-icon-box">
              <img
                src="/black-back-button.png"
                class="icon icon-white close-icon"
                alt=""
              />
            </span>

            <span>Отмена</span>
          </button>

          <button
            v-else
            class="btn back"
            type="button"
            @click="prevStep"
          >
            <span class="button-icon-box">
              <img
                src="/black-back-button.png"
                class="icon icon-white"
                alt=""
              />
            </span>

            <span>Назад</span>
          </button>

          <button
            class="btn next"
            type="button"
            :disabled="!formValid"
            @click="nextStep"
          >
            <span>
              {{ nextButtonTitle }}
            </span>

            <span class="button-icon-box next-icon-box">
              <img
                src="/black-back-button.png"
                class="icon icon-white rotate"
                alt=""
              />
            </span>
          </button>
        </div>

        <!-- Контент шага -->
        <div class="step-content">
          <component
            :is="currentStepComponent"
            v-model="formData"
            @valid="formValid = true"
            @not-valid="formValid = false"
          />
        </div>
      </div>
    </div>

    <Footer />

    <!-- Электронное подтверждение -->
    <CompanyDigitalSignDrawer
      v-if="showDigitalSignDrawer"
      @accepted="handleDigitalSignAccepted"
      @close="handleDigitalSignClose"
    />
  </div>

  <LoaderHyper v-if="isCreating" />

  <Snackbar />
</template>

<script setup>
import {
  computed,
  ref,
  watch
} from "vue";

import DefaultHeader
  from "../components/DefaultHeader.vue";

import CompanyDigitalSignDrawer
  from "../components/CompanyDigitalSignDrawer.vue";

import Footer
  from "../components/MiniFooter.vue";

import CompanyService
  from "../api/CompanyService.js";

import {
  useRouter
} from "vue-router";

import {
  useRoute
} from "vue-router";

// Шаги

import StepName
  from "../components/create-company/StepName.vue";

import StepSpecifics
  from "../components/create-company/StepSpecifics.vue";

import StepImages
  from "../components/create-company/StepImages.vue";

import StepEmail
  from "../components/create-company/StepEmail.vue";

import StepWebsite
  from "../components/create-company/StepWebsite.vue";

import StepLocation
  from "../components/create-company/StepLocation.vue";

import StepExtraImages
  from "../components/create-company/StepExtraImages.vue";

import StepSocial
  from "../components/create-company/StepSocial.vue";

import StepBenefits
  from "../components/create-company/StepBenefits.vue";

import LoaderHyper
  from "../components/create-company/LoaderHyper.vue";

import Snackbar
  from "../components/Snackbar.vue";

const route = useRoute();
const router = useRouter();

const steps = [
  StepName,
  StepSpecifics,
  StepImages,
  StepEmail,
  StepWebsite,
  StepLocation,
  StepExtraImages,
  StepSocial,
  StepBenefits
];

const optionalSteps = [
  5,
  7,
  8
];

const currentStep = ref(1);

const isPremiumMode = computed(() => {
  return route.query.premium === "true";
});

const isCreating = ref(false);
const totalSteps = steps.length;
const formValid = ref(false);

// MARK: - Digital Sign

const isDigitalSigned =
  localStorage.getItem(
    "is_digital_signed"
  ) === "true";

const showDigitalSignDrawer = ref(
  !isDigitalSigned
);

const digitalSignId = ref(null);

console.log(
  "✍️ Электронное подтверждение:",
  isDigitalSigned
);

// MARK: - Form

const formData = ref({
  name: "",
  specifics: "",
  aboutCompany: "",
  region: "",
  email: "",
  website: "",

  extraImages: [],
  extraImageURLs: [],
  isUploadingExtra: [],

  socials: {
    facebook: "",
    instagram: "",
    linkedin: "",
    twitter: "",
    telegram: "",
    youtube: ""
  },

  benefits: [],

  location: {
    latitude: null,
    longitude: null
  },

  street: "",
  urlOfLogo: "",
  urlOfBackground: ""
});

// MARK: - Watchers

watch(currentStep, (step) => {
  if (
    optionalSteps.includes(step)
  ) {
    formValid.value = true;
  }
});

watch(
  () => formData.value.specifics,

  (value) => {
    console.log(
      "🔥 [CreateCompany] formData.specifics =",
      value
    );

    console.log(
      "📦 [CreateCompany] formData =",
      JSON.parse(
        JSON.stringify(
          formData.value
        )
      )
    );
  }
);

watch(
  showDigitalSignDrawer,
  (value) => {
    console.log(
      "👀 showDigitalSignDrawer:",
      value
    );
  }
);

// MARK: - Computed

const currentStepComponent = computed(() => {
  return steps[
    currentStep.value - 1
  ];
});

const progressWidth = computed(() => {
  return `${
    (
      currentStep.value /
      totalSteps
    ) * 100
  }%`;
});

const isLastStep = computed(() => {
  return currentStep.value === totalSteps;
});

const nextButtonTitle = computed(() => {
  return isLastStep.value
    ? "Готово"
    : "Далее";
});

// MARK: - Navigation

function nextStep() {
  if (!isLastStep.value) {
    currentStep.value++;

    if (
      optionalSteps.includes(
        currentStep.value
      )
    ) {
      formValid.value = true;
    } else {
      formValid.value = false;
    }
  } else {
    submitCompany();
  }
}

function prevStep() {
  if (currentStep.value > 1) {
    currentStep.value--;
  }
}

function handleCancel() {
  window.history.back();
}

// MARK: - Digital Sign

function handleDigitalSignAccepted(id = null) {
  console.log(
    "✅ [CreateCompany] accepted event получен:",
    id
  );

  // Сначала мгновенно закрываем overlay
  showDigitalSignDrawer.value = false;

  // id может отсутствовать — для текущего flow это не критично
  digitalSignId.value = id;

  localStorage.setItem(
    "is_digital_signed",
    "true"
  );

  console.log(
    "✅ [CreateCompany] drawer закрыт:",
    showDigitalSignDrawer.value
  );
}

function handleDigitalSignClose() {
  console.log(
    "⚠️ Пользователь не принял условия"
  );

  router.back();
}

// MARK: - Create Company

async function submitCompany() {
  try {
    isCreating.value = true;

    const payload = {
      name:
        formData.value.name,

      specifics:
        formData.value.specifics,

      email:
        formData.value.email,

      urlOfLogo:
        formData.value.urlOfLogo,

      urlOfBackground:
        formData.value.urlOfBackground,

      aboutCompany:
        formData.value.aboutCompany,

      website:
        formData.value.website,

      street:
        formData.value.street,

      latitude:
        formData.value.location.latitude,

      longitude:
        formData.value.location.longitude,

      socialData: {
        facebook:
          formData.value.socials.facebook,

        instagram:
          formData.value.socials.instagram,

        linkedin:
          formData.value.socials.linkedin,

        twitter:
          formData.value.socials.twitter,

        telegram:
          formData.value.socials.telegram,

        youtube:
          formData.value.socials.youtube
      }
    };

    console.log(
      "📤 FINAL PAYLOAD:",
      payload
    );

    const response =
      await CompanyService
        .createCompany(payload);

    console.log(
      "🎉 Компания успешно создана:",
      response
    );

    showSnackbar(
      "Компания успешно создана 🎉"
    );

    router.push("/profile");
  } catch (error) {
    console.error(
      "❌ Ошибка создания компании:",
      error
    );

    showSnackbar(
      "Не удалось создать компанию 😢"
    );
  } finally {
    isCreating.value = false;
  }
}

// MARK: - Snackbar

function showSnackbar(message) {
  window.dispatchEvent(
    new CustomEvent(
      "snackbar",
      {
        detail: {
          message
        }
      }
    )
  );
}
</script>

<style scoped>
.page-wrapper {
  width: 100vw;
  height: 100vh;

  display: flex;
  flex-direction: column;
}

.page-bg {
  flex: 1;

  display: flex;
  flex-direction: column;
  align-items: center;

  padding-top: 30px;

  overflow: hidden;

  background: #f5f5f5;
}

.step-title-wrapper {
  width: 1100px;

  margin-bottom: 12px;
}

.step-title {
  margin: 0;

  color: #111111;

  font-family: "Eastman-Bold";
  font-size: 20px;
}

.step-container {
  width: min(1320px, calc(100vw - 64px));
  height: calc(100vh - 220px);

  display: flex;
  flex-direction: column;

  overflow: hidden;

  background: #ffffff;
  border-radius: 18px;

  box-shadow:
    0 4px 12px rgba(0, 0, 0, 0.05);
}

.progress-bar {
  height: 14px;

  background: #eaeaea;
}

.progress-fill {
  height: 100%;

  background: #2887f7;

  transition:
    width 0.3s ease;
}

/* Кнопки */

.step-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 12px;

  margin-top: 18px;
  margin-right: 20px;
}

.btn {
  display: flex;
  align-items: center;
  gap: 6px;

  padding:
    10px
    26px;

  border: none;
  border-radius: 30px;

  font-family: "Eastman-Medium";
  font-size: 14px;

  cursor: pointer;
}

.icon {
  width: 14px;
  height: 14px;
}

.icon-white {
  filter:
    brightness(0)
    invert(1);
}
/* Тёмная тема */

html[data-theme="dark"] .page-bg {
  background: #171717;
}

html[data-theme="dark"] .step-title {
  color: #ffffff;
}

html[data-theme="dark"] .step-container {
  background: #1c1c1e;

  border: 1px solid #2a2a2a;

  box-shadow: none;
}

html[data-theme="dark"] .progress-bar {
  background: #2a2a2a;
}

html[data-theme="dark"] .progress-fill {
  background: #3b82f6;
}

html[data-theme="dark"] .step-content {
  color: #e0e0e0;
}

html[data-theme="dark"] .btn.cancel {
  background: #9a2c2c;
}

html[data-theme="dark"] .btn.back {
  background: #4a4a4a;
}

html[data-theme="dark"] .btn.next {
  background: #2368d8;
}

html[data-theme="dark"] .icon-white {
  filter:
    brightness(0)
    invert(1);
}

/* Кнопки навигации */

.step-buttons {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 11px;

  flex-shrink: 0;

  margin-top: 18px;
  margin-right: 20px;
}

.btn {
  min-height: 46px;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 9px;

  padding:
    7px
    16px;

  border: 1px solid transparent;
  border-radius: 14px;

  font-family: "Eastman-Medium", sans-serif;
  font-size: 13px;
  line-height: 1;

  cursor: pointer;

  transition:
    color 0.2s ease,
    background-color 0.2s ease,
    background-position 0.3s ease,
    border-color 0.2s ease,
    opacity 0.2s ease,
    transform 0.2s ease,
    box-shadow 0.2s ease;
}

.button-icon-box {
  width: 28px;
  height: 28px;

  flex-shrink: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 9px;

  transition:
    background-color 0.2s ease,
    transform 0.2s ease;
}

.icon {
  width: 14px;
  height: 14px;

  display: block;
}

.icon-white {
  filter:
    brightness(0)
    invert(1);
}

.rotate {
  transform: rotate(180deg);
}

/* Отмена */

.btn.cancel {
  min-width: 116px;

  color: #ffffff;

  background:
    linear-gradient(
      135deg,
      #df5b66,
      #ca4452
    );

  box-shadow:
    0 7px 16px
    rgba(201, 67, 81, 0.2);
}

.btn.cancel:hover:not(:disabled) {
  transform: translateY(-1px);

  box-shadow:
    0 10px 21px
    rgba(201, 67, 81, 0.28);
}

.btn.cancel:active:not(:disabled) {
  transform: translateY(0);
}

/* Назад */

.btn.back {
  min-width: 116px;

  color: #ffffff;

  background:
    linear-gradient(
      135deg,
      #737b88,
      #59606c
    );

  box-shadow:
    0 7px 16px
    rgba(72, 79, 92, 0.18);
}

.btn.back:hover:not(:disabled) {
  transform: translateY(-1px);

  box-shadow:
    0 10px 21px
    rgba(72, 79, 92, 0.25);
}

.btn.back:hover:not(:disabled)
.button-icon-box {
  transform: translateX(-2px);
}

.btn.back:active:not(:disabled) {
  transform: translateY(0);
}

/* Далее */

.btn.next {
  min-width: 136px;

  color: #ffffff;

  background:
    linear-gradient(
      110deg,
      #2887f7,
      #5368e8,
      #2887f7
    );

  background-size: 180% 100%;
  background-position: 0 50%;

  box-shadow:
    0 8px 18px
    rgba(40, 111, 230, 0.24);
}

.btn.next:hover:not(:disabled) {
  background-position: 100% 50%;

  transform: translateY(-1px);

  box-shadow:
    0 11px 23px
    rgba(40, 111, 230, 0.32);
}

.btn.next:hover:not(:disabled)
.next-icon-box {
  transform: translateX(2px);
}

.btn.next:active:not(:disabled) {
  transform: translateY(0);
}

/* Неактивная кнопка */

.btn.next:disabled {
  color: rgba(255, 255, 255, 0.75);

  background: #a7c5f3;

  cursor: not-allowed;
  opacity: 0.62;

  box-shadow: none;
  transform: none;
}

/* Тёмная тема */

html[data-theme="dark"] .btn.cancel {
  background:
    linear-gradient(
      135deg,
      #a63b46,
      #852c35
    );

  box-shadow:
    0 7px 16px
    rgba(80, 20, 28, 0.25);
}

html[data-theme="dark"] .btn.back {
  background:
    linear-gradient(
      135deg,
      #555c67,
      #3f454e
    );

  box-shadow:
    0 7px 16px
    rgba(0, 0, 0, 0.2);
}

html[data-theme="dark"] .btn.next {
  background:
    linear-gradient(
      110deg,
      #286fd8,
      #4d5fda,
      #2877dd
    );

  background-size: 180% 100%;
}

html[data-theme="dark"] .btn.next:disabled {
  background: #3f4c61;
  box-shadow: none;
}

html[data-theme="dark"] .icon-white {
  filter:
    brightness(0)
    invert(1);
}

/* Прогресс */

.progress-bar {
  position: relative;

  height: 9px;

  margin:
    18px
    20px
    0;

  overflow: hidden;

  background: #edf0f4;
  border: 1px solid rgba(40, 55, 80, 0.04);
  border-radius: 999px;

  box-shadow:
    inset 0 1px 3px
    rgba(30, 45, 70, 0.08);
}

.progress-fill {
  position: relative;

  height: 100%;
  min-width: 9px;

  overflow: hidden;

  background:
    linear-gradient(
      90deg,
      #2385f6 0%,
      #5368e8 55%,
      #31a5f4 100%
    );

  border-radius: 999px;

  box-shadow:
    0 2px 8px
    rgba(40, 125, 240, 0.28);

  transition:
    width 0.5s
    cubic-bezier(0.22, 1, 0.36, 1);
}

.progress-fill::after {
  content: "";

  position: absolute;
  top: 50%;
  right: 3px;

  width: 4px;
  height: 4px;

  background: rgba(255, 255, 255, 0.9);
  border-radius: 50%;

  transform: translateY(-50%);

  box-shadow:
    0 0 7px
    rgba(255, 255, 255, 0.8);
}

.progress-shine {
  position: absolute;
  inset: 0;

  width: 42%;

  background:
    linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.5),
      transparent
    );

  transform: translateX(-120%);

  animation:
    progress-shine-animation
    2.7s
    ease-in-out
    infinite;
}

@keyframes progress-shine-animation {
  0% {
    transform: translateX(-120%);
  }

  55%,
  100% {
    transform: translateX(285%);
  }
}

html[data-theme="dark"] .progress-bar {
  background: #292b30;
  border-color: rgba(255, 255, 255, 0.04);

  box-shadow:
    inset 0 1px 3px
    rgba(0, 0, 0, 0.28);
}

html[data-theme="dark"] .progress-fill {
  background:
    linear-gradient(
      90deg,
      #347ee4 0%,
      #6267e9 55%,
      #359be7 100%
    );

  box-shadow:
    0 2px 9px
    rgba(46, 116, 224, 0.3);
}

@media (prefers-reduced-motion: reduce) {
  .progress-shine {
    animation: none;
  }
}

</style>